export const helpComponentConstants = {
	IMG_PATH: 'assets/icons/help/',

	SLIDES_DATA: [
		{
			text: [
				'Geo filter',
				'Right click your area of interest',
				'Press the central button',
				'Now the app will fetch the overlays for this location'
			],
			image: [
				'Frame 86.png',
				'Frame 87.png'
			]
		},
		{
			text: [
				'Time Filter',
				'Set the time of interest',
				'Double click the pink circles to open overlays',
				'You can navigate between overlays by using the arrows and the keyboard'
			],
			image: [
				'Frame 88.png',
				'Frame 89.png'
			]
		},
		{
			text: [
				'Data Filter',
				'Select the input data',
				'Modify the query by using the filters',
				'See the number of available overlays in the filters menu and in the status bar'
			],
			image: [
				'Frame 90.png',
				'Frame 91.png'
			]
		},
		{
			text: [
				'Tool Menu',
				'Use the tools to support your work',
				'You can draw annotations to indicate findings',
				'You can also use image processing options, make measurements and more'
			],
			image: [
				'Frame 92.png',
				'Frame 93.png'
			]
		},
		{
			text: [
				'Context Menu',
				'Navigate between overlays by right click',
				'See all available options',
				'Good luck!'
			],
			image: [
				'Frame 94.png',
				'Frame 95.png'
			]
		}
	]
};
